import "../styles/CryptoTextArea.css";
import { useGame } from "../GameContext";

const TextArea = () => {
  const {guessedWords} = useGame()

  return (
    <div className="crypto-Area">
      <div className="crypto-subtitle">Найденные слова</div>
      <div className="crypto-textArea">{guessedWords.map((word)=>{
        return (
          <div>
            {word}
            </div>
        )
      })}</div>
       
    </div>
  );
};
export default TextArea;
